import PropTypes from 'prop-types';
import React from 'react';

import {
  TEMPLATE_QUERY,
  TEMPLATE_VIEW_QUERY,
  WORK_EXP_QUERY,
} from '@glass/common/modules/pages/queryParams';
import { WORK_EXPERIENCE_SECTION_ID } from '@glass/web/modules/content/pages/contentIds';

import ExperienceSection from '@glass/shared/components/Section/ExperienceSection/ExperienceSection';
import withTrackingContext from '@glass/shared/modules/tracking/withTrackingContext';

export const NO_WORK_EXP_QUERY_VALUE = '0';
export const MINIMAL_WORK_EXP_QUERY_VALUE = '1';
export const SKIP_QUERY_VALUE = 'x';

const STATIC_WORK_EXPERIENCE_OPTIONS = [
  {
    text: 'No experience',
    params: {
      [WORK_EXP_QUERY]: NO_WORK_EXP_QUERY_VALUE,
    },
  },
  {
    text: '3 or less years',
    params: {
      [WORK_EXP_QUERY]: MINIMAL_WORK_EXP_QUERY_VALUE,
    },
  },
  {
    text: '3-5 years',
    params: {
      [WORK_EXP_QUERY]: 3,
    },
  },
  {
    text: '5-8 years',
    params: {
      [WORK_EXP_QUERY]: 5,
    },
  },
  {
    text: '8+ years',
    params: {
      [WORK_EXP_QUERY]: 8,
    },
  },
];
const ctaQueryParams = {
  [TEMPLATE_VIEW_QUERY]: TEMPLATE_QUERY,
};

const WorkExperienceSection = React.forwardRef(
  (
    {
      title,
      subtitle,
      isAlternatingColor,
      onButtonClick,
      disableCta,
      isNoXPadding,
      overflow,
      outerSpacing,
      spacing,
      type,
      shallow,
      persistQueryParams,
      titleComponent,
      titleVariant,
    },
    ref,
  ) => {
    return (
      <ExperienceSection
        ref={ref}
        ctaQueryParams={ctaQueryParams}
        ctaText="Start with your experience"
        disableCta={disableCta}
        isAlternatingColor={isAlternatingColor}
        isNoXPadding={isNoXPadding}
        options={STATIC_WORK_EXPERIENCE_OPTIONS}
        outerSpacing={outerSpacing}
        overflow={overflow}
        persistQueryParams={persistQueryParams}
        shallow={shallow}
        spacing={spacing}
        subtitle={subtitle}
        title={title}
        titleComponent={titleComponent}
        titleVariant={titleVariant}
        type={type}
        onButtonClick={onButtonClick}
      />
    );
  },
);

WorkExperienceSection.propTypes = {
  disableCta: PropTypes.bool,
  isAlternatingColor: PropTypes.bool,
  isNoXPadding: PropTypes.bool,
  onButtonClick: PropTypes.func,
  outerSpacing: PropTypes.number,
  overflow: PropTypes.string,
  persistQueryParams: PropTypes.bool,
  shallow: PropTypes.bool,
  spacing: PropTypes.number,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  titleComponent: PropTypes.string,
  titleVariant: PropTypes.string,
  type: PropTypes.string,
};

WorkExperienceSection.defaultProps = {
  title: `Ready to start $(verbWords.wording) your $(resumeWords.singular)?`,
  subtitle: `How much experience do you have? We'll offer custom-tailored recommendations to help you $(verbWords.singular) the $(adjectiveWords.singular) $(resumeWords.singular)`,
  type: WORK_EXPERIENCE_SECTION_ID,
};

export default React.memo(withTrackingContext(WorkExperienceSection, WORK_EXPERIENCE_SECTION_ID));
